
import Vue from "vue";
import { Browse } from "@/models/browse";
import { UserConfigService } from "../../services/user-config-service";
export default Vue.extend({
	props: {
		title: {
			type: String
		},
		browses: {
			type: Array as ()=>Browse[],
			required: true
		}
	},
	methods: {
		onBrowseClick(browse:Browse){
			this.$emit("click", browse);
		},
		canEditViews(browse:Browse):boolean{
			return UserConfigService.hasCurrentUserPermission(p=>p.getPermissionsByBrowseID(browse.ID)?.CanMakeViews);
		},
		getIconClass(browse:Browse):string{
			return Browse.getIconClassByBrowseId(browse.ID);
		}
	}
});
